import createPdf, {
  baseFontSize,
  createTableHeader,
  createDividerRow,
  createPages,
  createDocument,
} from '../createPdf';

import { flatMap, pick } from 'lodash';

const SPACE = ' ';

const yearOfBirth = (dateOfBirth) => {
  if (dateOfBirth == SPACE)
    return SPACE;

  return dateOfBirth.split('.')[2];
}

const createAthleteRow = (athlete, index) => [
  { text: index + 1, alignment: 'right' },
  { text: athlete.lotNumber, alignment: 'right' },
  { text: athlete.name },
  { text: yearOfBirth(athlete.dateOfBirth) },
  { text: athlete.teams.join(', ') },
  { text: athlete.contests.join(SPACE) },
  { text: athlete.entryTotal, alignment: 'right' },
];

const createStartListPage = startList => {
  let previousCategory;
  const columns = ['', 'LOT', 'NAME', 'D.O.B.', 'TEAM', 'CATEGORY', 'ENTRY'];
  const widths = [10, 15, '*', 45, 50, 75, 25];
  const rows = flatMap(startList.athletes, (athlete, index) => {
    const divider = athlete.category !== previousCategory &&
      !!index && [createDividerRow(7, athlete.category)];
    previousCategory = athlete.category;
    const athleteRow = createAthleteRow(athlete, index);
    return [...(divider || []), athleteRow];
  });
  return [
    {
      text: `START LIST ${startList.title}`,
      style: 'header',
    },
    {
      table: {
        headerRows: 1,
        fontSize: baseFontSize / 1.2,
        widths,
        body: [createTableHeader(columns), ...rows],
      },
    },
  ];
};

const createStartListsPdf = (startLists, meta) => {
  const [event] = meta.orm.events;
  const documentDefinition = createDocument(
    'Start Lists',
    createPages(
      startLists,
      createStartListPage,
      pick(event, 'title', 'location', 'duration'),
    ),
  );

  return createPdf(documentDefinition);
};

export default createStartListsPdf;



// WEBPACK FOOTER //
// ./src/pages/Home/startLists/createStartListsPdf.js